import { TagListProps } from "common/Component/TagList/types";
import { fromStyleLocals } from "common/css";
import { minimumInputCharSearch } from "common/picker/constant";
import { TagListState } from "common/picker/reducer/types";
import { debounce, size, trim } from "lodash";
import { Component, h } from "preact";

import * as style from "./TagList.less";
const css = fromStyleLocals(style.locals);

export abstract class TagList<TItem, TCriteria> extends Component<
  TagListProps<TItem, TCriteria> & TagListState<TItem>,
  {}
> {
  public onSearchLast = debounce(() => {
    if (size(this.input.value) < minimumInputCharSearch) {
      this.props.onInput("");
      this.props.onFocus();
      return;
    }
    const by = this.by.value;
    const text = trim(this.input.value);
    const from =
      this.props.hasPortfolio && !this.from.checked
        ? "from:portfolio"
        : "from:database";
    const terms = `${by}${text} ${from}`;
    this.props.onInput(terms);
    this.props.onFocus();
  }, 200);

  protected by: any;
  protected inputContainer: any;
  protected input: any;
  private from: any;

  public render() {
    const hasError =
      this.props.status === "error" || this.props.state === "error";
    const tagListClasses = [
      "multi-select",
      ...(hasError ? ["has-feedback"] : []),
    ];
    return (
      <div
        class={
          this.props.displayInline
            ? css("ic-tag-list-inline", "form-horizontal")
            : css("ic-tag-list", "form-horizontal")
        }
      >
        <style>{style.toString()}</style>

        <div
          class={css(...tagListClasses)}
          ref={inputContainer =>
            (this.inputContainer = inputContainer as HTMLDivElement)
          }
        >
          <ul>
            {this.renderTag(this.props.onRemove, this.props.tags)}
            <li class={css("input")}>
              {this.props.disabled
                ? ""
                : this.renderInput(hasError, this.props.placeholder)}
            </li>
          </ul>
        </div>

        {!this.props.displaySearchBy
          ? ""
          : this.renderSelectBy(
              this.props.selectedSearchBy,
              this.props.disabled
            )}

        {!this.props.hasPortfolio ? (
          ""
        ) : (
          <div>
            <div class={css("checkbox")}>
              <label>
                <input
                  disabled={this.props.disabled}
                  onChange={this.onSearchLast}
                  ref={from => (this.from = from as HTMLInputElement)}
                  type="checkbox"
                />
                <span>All database</span>
              </label>
            </div>
          </div>
        )}
      </div>
    );
  }

  public onBlur = () => {
    if (this.inputContainer.classList.contains("focus")) {
      this.inputContainer.classList.remove("focus");
    }
  };

  public onFocus = () => {
    if (!this.inputContainer.classList.contains("focus")) {
      this.inputContainer.classList.add("focus");
    }
    this.props.onFocus();
  };

  // tslint:disable-next-line:no-empty
  protected onKeyDown = (_: any) => {};

  protected renderInput(hasError: boolean, placeholder: string): any {
    const input = (
      <input
        class={css("form-control")}
        onBlur={this.onBlur}
        onKeyDown={this.onKeyDown}
        onFocus={this.onFocus}
        onInput={this.onSearchLast}
        placeholder={placeholder}
        ref={this.setInput}
        type="text"
      />
    );

    const inputErrorIcon = hasError
      ? [
          <span
            class={css("fa", "fa-exclamation", "form-control-feedback")}
            aria-hidden="true"
          />,
          <span class="sr-only">(error)</span>,
        ]
      : [];
    return [input, ...inputErrorIcon];
  }

  protected abstract renderTag(_: (item: TItem) => void, __: TItem[]): any;

  protected abstract renderSelectBy(_: string, __: boolean): JSX.Element;

  private setInput = (input: HTMLInputElement) => {
    if (input != null) {
      this.input = input;
    }
  };
}
